import styled from 'styled-components'

import { Radio, WorkflowDateTimePicker } from '@/components/Form'
import {
  ExternalLink as ExternalLinkIcon,
  PaperPlane,
  CalendarTime as ScheduledIcon,
  Wand as WandIcon
} from '@/components/Icons'
import ArrowsOpposite from '@/components/Icons/ArrowsOpposite'
import { ImagePreview } from '@/components/ImagePreview'
import { FlexColumn, Row } from '@/components/StyledComponents'
import { Title } from '@/pages/SpaceAppBuilder/utilities/StyledComponents'

export const StyledCenterAlignedRow = styled.div`
  display: flex;
  align-items: center;
`

export const StyledTopAlignedRow = styled.div`
  display: flex;
  align-items: flex-start;
`

export const StyledScheduledIcon = styled(ScheduledIcon)`
  width: 20px;
  height: 20px;
  margin-top: -2px;
  color: var(--wg-dark-blue);
`

export const StyledPaperPlaneIcon = styled(PaperPlane)`
  color: #1a56db;
`

export const StyledArrowsOpposite = styled(ArrowsOpposite)`
  color: var(--wg-dark-blue);
`

export const NodeHeading = styled(Title)`
  max-width: 290px;
  white-space: nowrap;
  width: auto;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
`

export const ContextPill = styled.div`
  background-color: #f7f8fa;
  margin-top: 5px;
  margin-left: -2px;
  padding: 2px 6px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
`
export const StyledDateTimePicker = styled(WorkflowDateTimePicker)`
  .react-datepicker-wrapper {
    margin-bottom: 0;
    margin-left: 0;
    width: 100%;
    margin-top: 10px;
  }
`
export const StyledRadio = styled(Radio)`
  margin-top: 1rem;
  margin-bottom: 1rem !important;
  display: flex;
  flex-direction: row;
  .form_field {
    display: flex;
  }
  @media (max-width: 600px) {
    flex-direction: column;
  }
`

export const StyledRadioInput = styled(Radio.Input)`
  && {
    &.form__field {
      margin-bottom: 1rem !important;
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0 !important;
    }

    .field__input {
      &:checked {
        border-color: #1a56db;
      }
    }

    .field__label {
      font-size: 1rem;
    }

    .field__description {
      color: gray;
      margin: 10px 0 0 33px;
      text-align: left;
    }
  }
`
export const StyledFrequencyTextContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
`

export const StyledWandIcon = styled<any>(WandIcon)`
  color: var(--wg-blue-link);
`

export const VariableButton = styled.button`
  background: #ffffff;
  border: 1px solid rgb(209 213 219 / 1);
  padding: 0.25rem 0.25rem 0.25rem 1rem;
  flex: 1;
  border-radius: 4px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  max-width: 50px;
  min-width: 40px;
  height: 47px;
  margin-left: 7px;
  color: #1a56db;
  transition: box-shadow 0.1s;
  cursor: pointer;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.3) 0 0 4px;
  }

  ${StyledWandIcon} {
    margin-right: 10px;
  }
`

export const SecondaryRoundedButton = styled.button`
  border: 1px solid #1a56db;
  min-width: 120px;
  padding: 0.5rem;
  border-radius: 25px;
  text-align: center;
  font-size: 14px;
  margin-top: -5px;
  background-color: white;
  margin-left: auto;
  display: flex;
  color: #1a56db;
  transition: box-shadow 0.1s;
  cursor: pointer;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.3) 0 0 4px;
  }

  ${StyledWandIcon} {
    margin-right: 10px;
  }
`

export const VariableLinkButton = styled.button`
  border: none;
  min-width: 120px;
  padding: 0.75rem 1.5rem;
  text-align: center;
  font-size: 15px;
  border-radius: 25px;
  align-items: center;
  margin-top: -5px;
  background-color: transparent;
  margin-left: auto;
  display: flex;
  color: #1a56db;
  cursor: pointer;

  ${StyledWandIcon} {
    margin-right: 10px;
  }
`

export const VariableInputContainer = styled.div`
  position: relative;
  width: 100%;
  p {
    margin: 5px 0;
  }
  padding-bottom: 5px;
`

export const StyledDivider = styled.hr`
  clear: none;
  position: relative;
  top: 0.5em;
  width: 100%;
  border: 0;
  height: 0;
  border-bottom: 0.5px solid #cccccc;
  margin: 0.75rem 0;
`

export const StyledBlockTitleBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  div.icon {
    padding: 0.1rem;
    margin: 0 0.1rem;
    cursor: pointer;
  }

  .remove {
    flex: 0 17px;
  }
`

export const BlockTitle = styled.label`
  color: #4b4b4b;
  font-size: 0.95rem;
  font-weight: bold;
  display: block;
  margin-right: auto;
  margin-bottom: 0;
`

export const BlockBorder = styled.div`
  border-radius: 5px;
  border: 1px solid #cccccc;
  padding: 10px;
  margin: 10px 0;
`

export const StyledBackNavigationContainer = styled.div`
  margin-bottom: 1rem;
  margin-left: -1rem;
`

export const StyledBackNavigationLink = styled.a`
  color: var(--wg-blue-link);
  cursor: pointer;
  font-size: 0.875rem;
  position: relative;
  margin-left: 2rem;
  width: 220px;

  svg {
    left: -15px;
    margin-right: 5px;
    position: absolute;
    top: 3px;
  }
`

export const StyledImageContainer = styled(ImagePreview)`
  && {
    background-color: #ffffff;
    height: 100px;
    width: 100px;
    border-radius: 8px;
  }
`

export const StyledFlexEndColumn = styled(FlexColumn)`
  display: flex;
  align-items: flex-end;
  flex: 1 0 40%;
`

export const StyledFlexColumn = styled(FlexColumn)`
  align-items: flex-start;
  flex: 1 0 50%;
`

const StyledExternalLinkIcon = styled(ExternalLinkIcon)`
  color: var(--wg-dark-blue);
  height: 1em;
`
const LinkContainer = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 10px;
  a {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    gap: 5px;
  }
`
export const ExternalLink = ({ href, children, className }: any) => {
  return (
    <LinkContainer className={className}>
      <a href={href} target="_blank" rel="noreferrer">
        {children}
        <StyledExternalLinkIcon />
      </a>
    </LinkContainer>
  )
}

export const Actions = styled(Row)`
  display: flex;
  width: 75px;
  padding-top: 0.5em;
  justify-content: end;
  @media (max-width: 1000px) {
    width: 100%;
  }
`
export const Action = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  font-size: 12px;
  color: #4b4b4b;
  margin-right: 30px;
  cursor: pointer;
`
